import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import SampleRequest from "../_shark_models/SampleRequest";

class SampleRequestManager extends ManagerBase {
	constructor () {
		super("sampleRequestManager");
		this.remoteClassName = "sample-request";
	}

	async getDescription (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "get-description";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items?.[0],
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		return super.getFilteredList("sampleRequestList", SampleRequest, {incrementalRequest, filters, range});
	}

	async revertStatus (item, newStatus, reason = "") {
		const rd = NousCore.api.createRequest({ item: { reason, guid: item.guid, newStatus }});
		const requestedAction = "revert-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async setLabCodes (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "set-lab-codes";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async setShippingData (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "set-shipping-data";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async setStatus (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "set-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const sampleRequestManager = new SampleRequestManager();

Shark.registerController(sampleRequestManager);

export default sampleRequestManager;
